<app-service-settings-common
    [hideShareWithOtherServicesInput]="true"
    [settingsKey]="SERVICE_SETTINGS_SANCTION_TYPE_KEY"
    [title]="'workData.sanction.labelMulti'"
></app-service-settings-common>
